import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { SettlementService } from './settlement.service';
import * as moment from 'moment';
import { MatDatepickerInputEvent, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
@Component({
    selector: 'app-settlement',
    templateUrl: './settlement.component.html',
    styleUrls: ['./settlement.component.css']
})
export class SettlementComponent implements OnInit {
    displayedColumnsWithdrawl = [
        'action',
        'currency',
        'assetid',
        'withdrawl',
    ];
    displayedColumnsSource = [
        'source',
        'currency',
        'assetid',
        'amount',
    ];
    public dataSource: any = new MatTableDataSource();
    public dataSource2: any = new MatTableDataSource();
    @ViewChild('paginator', { read: MatPaginator }) paginator: MatPaginator;
    @ViewChild('paginator1', { read: MatPaginator }) paginator1: MatPaginator;
    @ViewChild('sort', { read: MatSort }) sort: MatSort;
    @ViewChild('sort1', { read: MatSort }) sort1: MatSort;
    filter: any = {};
    fromDate: any;
    toDate: any;
    public selectedDate = new Date(new Date().setDate(new Date().getDate() - 7));
    public selectedDate1 = new Date();
    selectedAssetId: string;
    pageSize = 10;
    pageSize1 = 5;
    pageSizeCwallets = 5;
    currentPage = 0;
    currentPage1 = 0;
    currentPageCwallets = 0;
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];
    pageSizeOptions1: number[] = [5, 10, 25, 50, 100];
    pageSizeOptionsCwallets: number[] = [5, 10, 25, 50, 100];
    constructor(private userService: UserService, private settlement: SettlementService) {
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }

    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    async pageChanged(event: PageEvent) {
        this.pageSize = event.pageSize;
        this.currentPage = event.pageIndex;
    }
    async pageChanged1(event: PageEvent) {
        this.pageSize1 = event.pageSize;
        this.currentPage1 = event.pageIndex;
    }

    async pageChangedCwallets(event: PageEvent) {
        this.pageSizeCwallets = event.pageSize;
        this.currentPageCwallets = event.pageIndex;
    }

    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.settlement.getSettlement(this.filter).subscribe((success) => {
                let res = success.data.map((element: settlementData) => {
                    return element;
                })
                this.dataSource = new MatTableDataSource(res);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }

    async exportArray() {
        if (this.dataSource.filteredData) {
            const settlement = await this.dataSource.filteredData.map((x: settlementData) => ({
                'Asset': x.assetid,
                'Withdrawl': x.withdrawl,
            }));
            TableUtil.exportArrayToExcel(settlement, "settlement");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    ngOnInit() {
        this.csrf();
        // this.dataSource2 = new MatTableDataSource([]);
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');

    }
    applyFilterCwallets(value) {
        value = value.trim(); // Remove whitespace
        value = value.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource2.filter = value;
    }

    getBlance(assetid: string, currency: string) {
        this.selectedAssetId = assetid;
        this.userService.csrf().subscribe(data => {
            this.settlement.getSettlementBlance({_csrf:data._csrf, assetid, currency}).subscribe((success) => {
                let res = success.data.map((element: blanceData) => {
                    return element;
                })
                this.dataSource2 = new MatTableDataSource(res);
                this.dataSource2.paginator = this.paginator
                this.dataSource2.sort = this.sort;
            })
        })
    }

}

export interface settlementData {
    assetid: string,
    currency: string,
    withdrawl: number,
}

export interface blanceData {
    source: string,
    currency: string,
    assetid: string,
    amount: number,
}


// WEBPACK FOOTER //
// ./src/app/settlement/settlement.component.ts